import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { timer } from 'rxjs/internal/observable/timer';

export interface ConfirmData {
  title: string,
  message: string,
  cancelBtnText?: string,
  confirmBtnText?: string,
  timer?: number
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {

  time: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmData) {
    if (this.data.timer) {
      const confirmSecondTimer = timer(0, 1000).subscribe((time) => {
        this.time = this.data.timer - time;
      });

      const confirmTimer = timer(this.data.timer * 1000).subscribe(() => {
        confirmSecondTimer.unsubscribe();
      });

      this.dialogRef.beforeClosed().subscribe(() => {
        confirmTimer.unsubscribe();
        confirmSecondTimer.unsubscribe();
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

}
